import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import LocationDropdown from '../../../../../../components/forms/LocationDropdown';
import CustomInput from '../../../../../../components/forms/CustomInput';

const BasicInfoSection = ({
  formData,
  setFormData,
  handleChange,
  locations,
  isEdit,
  role,
  onExtractCoordinates
}) => {
  const handlePhoneChange = (val, data) => {
    const dial = data.dialCode;
    let cleaned = val;
    if (val.startsWith(dial)) {
      cleaned = val.slice(dial.length);
    }
    const formattedCode = dial.startsWith('+') ? dial : `+${dial}`;

    setFormData((prev) => ({
      ...prev,
      phone_number: cleaned,
      country_code: formattedCode
    }));
  };

  const getPhoneInputValue = () => {
    const dial = (formData.country_code || '91').replace(/\+/g, '');
    const num = formData.phone_number || '';
    return dial + num;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
      {/* Business Name */}
      <CustomInput
        label="Business name *"
        name="business_name"
        value={formData.business_name}
        onChange={handleChange}
        placeholder="Enter business name"
        required
      />

      {/* Owner Name */}
      <CustomInput
        label="Owner name *"
        name="owner_name"
        value={formData.owner_name}
        onChange={handleChange}
        placeholder="Enter owner name"
        required
      />

      {/* Email */}
      <CustomInput
        label="Email address *"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="partner@example.com"
        required={!isEdit}
        disabled={isEdit}
      />

      {/* Phone Number */}
      <div className="space-y-1.5 sm:space-y-2">
        <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
          Phone number <span className="text-rose-500 ml-0.5">*</span>
        </label>
        <div className="flex gap-2 sm:gap-3 h-[42px]">
          <div className="phone-flag-wrapper bg-white rounded-xl px-2.5 sm:px-4 flex items-center gap-1 border border-slate-200 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary flex-shrink-0 shadow-sm">
            <PhoneInput
              country={'in'}
              value={getPhoneInputValue()}
              onChange={handlePhoneChange}
              containerClass="!w-auto !border-none !static flex items-center"
              inputClass="!hidden"
              buttonClass="!bg-transparent !border-none !static !p-0 !m-0 !w-auto !h-auto flex items-center"
              dropdownClass="!rounded-2xl !mt-8 !border-slate-100 !shadow-xl !z-[110]"
              enableSearch={true}
            />
            <span className="text-xs sm:text-sm font-bold text-slate-700 ml-1">
              {formData.country_code?.startsWith('+')
                ? formData.country_code
                : `+${formData.country_code || '91'}`}
            </span>
          </div>
          <input
            required
            type="text"
            name="phone_number"
            value={formData.phone_number}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                phone_number: e.target.value.replace(/\D/g, '')
              }))
            }
            className="flex-1 min-w-0 bg-white border border-slate-200 focus:border-primary focus:ring-1 focus:ring-primary rounded-xl px-3.5 sm:px-4 py-2.5 text-xs sm:text-sm outline-none transition-all text-slate-700 font-normal shadow-sm h-[42px]"
            placeholder="Enter phone number"
          />
        </div>
      </div>

      {/* Location Dropdown */}
      <LocationDropdown
        value={formData.location_id}
        onChange={(val) => setFormData((prev) => ({ ...prev, location_id: val }))}
        locations={locations}
        valueKey="_id"
        label="Location *"
        placeholder="Select a location"
        required
      />

      {/* Address */}
      <div className="space-y-1.5 sm:space-y-2 col-span-1 md:col-span-2">
        <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
          Address <span className="text-rose-500 ml-0.5">*</span>
        </label>
        <textarea
          required
          name="address"
          value={formData.address}
          onChange={handleChange}
          rows="2"
          className="w-full bg-white border border-slate-200 focus:border-primary focus:ring-1 focus:ring-primary rounded-xl px-3.5 sm:px-4 py-2.5 text-xs sm:text-sm outline-none transition-all resize-none text-slate-700 font-normal shadow-sm"
          placeholder="Full address"
        />
      </div>

      {/* City */}
      <CustomInput
        label="City *"
        name="city"
        value={formData.city}
        onChange={handleChange}
        placeholder="City"
        required
      />

      {/* Pincode */}
      <CustomInput
        label="Pincode *"
        name="pincode"
        value={formData.pincode}
        onChange={handleChange}
        placeholder="Pincode"
        required
      />

      {/* Description */}
      <div className="space-y-1.5 sm:space-y-2 col-span-1 md:col-span-2">
        <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
          Description {role === 'Restaurant' ? <span className="text-rose-500 ml-0.5">*</span> : ''}
        </label>
        <textarea
          required={role === 'Restaurant'}
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows="3"
          className="w-full bg-white border border-slate-200 focus:border-primary focus:ring-1 focus:ring-primary rounded-xl px-3.5 sm:px-4 py-2.5 text-xs sm:text-sm outline-none transition-all resize-none text-slate-700 font-normal shadow-sm"
          placeholder="Tell us about the business..."
        />
      </div>

      {/* Google Maps URL */}
      <div className="space-y-1.5 sm:space-y-2 col-span-1 md:col-span-2">
        <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
          Google Map URL <span className="text-rose-500 ml-0.5">*</span>
        </label>
        <div className="relative">
          <input
            required
            type="url"
            name="map_url"
            value={formData.map_url}
            onChange={handleChange}
            className="w-full bg-white border border-slate-200 focus:border-primary focus:ring-1 focus:ring-primary rounded-xl pl-3.5 pr-20 sm:pr-24 py-2.5 text-xs sm:text-sm outline-none transition-all text-slate-700 font-normal shadow-sm h-[42px]"
            placeholder="Paste Google Maps URL"
          />
          <button
            type="button"
            onClick={onExtractCoordinates}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-teal-50 hover:bg-teal-100 text-[#067978] font-bold text-[11px] sm:text-xs px-3 sm:px-4 py-1.5 rounded-lg transition-colors cursor-pointer"
          >
            Extract
          </button>
        </div>
      </div>

      {/* Latitude */}
      <CustomInput
        label="Latitude"
        name="latitude"
        value={formData.latitude}
        onChange={handleChange}
        placeholder="15.XXXX"
      />

      {/* Longitude */}
      <CustomInput
        label="Longitude"
        name="longitude"
        value={formData.longitude}
        onChange={handleChange}
        placeholder="73.XXXX"
      />
    </div>
  );
};

export default BasicInfoSection;
